/**
 * Outbound 工作台深链纯函数（零 DOM）。
 * 只拼 `/agent` 或 `/m/agent` 的 token + sessionId；不带访客 daji_* query。
 */

export interface ComposeAgentUrlParams {
  token: string;
  sessionId: string;
  mobile?: boolean;
}

/**
 * 业务 ID 强制非空 string；0 → '0'（避免雪花/数值精度与空值混淆）。
 * null / undefined / '' 抛 `DajiCS.outbound: missing ${field}`。
 */
export function requireStringId(value: unknown, field: string): string {
  if (value === null || value === undefined || value === '') {
    throw new Error(`DajiCS.outbound: missing ${field}`);
  }
  return String(value);
}

/**
 * `${baseUrl}/agent?token=&sessionId=` 或 mobile 时 `/m/agent?...`
 * baseUrl 去尾 `/`；token/sessionId 经 requireStringId；query 做 encodeURIComponent。
 */
export function composeAgentUrl(baseUrl: string, params: ComposeAgentUrlParams): string {
  const root = String(baseUrl ?? '').replace(/\/$/, '');
  const token = requireStringId(params.token, 'token');
  const sessionId = requireStringId(params.sessionId, 'sessionId');
  const path = params.mobile ? '/m/agent' : '/agent';
  const qs = [`token=${encodeURIComponent(token)}`, `sessionId=${encodeURIComponent(sessionId)}`].join('&');
  return `${root}${path}?${qs}`;
}
